// [ 'customer', 'industry-participant', 'service-provider', 'platform-admin', 'property-agent' ] allowed roles for users
const UserRole = {
  Agent: 'property-agent',
  Customer: 'customer',
  ServiceProvider: 'service-provider',
  PlatformAdmin: 'platform-admin',
};

export default UserRole;
